import 'normalize.css';
import './index.scss';
import 'containers/AuthPages/AuthPages.scss';

import React from 'react';
import ReactDOM from 'react-dom';
import thunkMiddleware from 'redux-thunk'
import {createStore, combineReducers, applyMiddleware} from 'redux';
import {browserHistory} from 'react-router';
import {syncHistoryWithStore, routerReducer, routerMiddleware} from 'react-router-redux';
import {AppContainer} from 'react-hot-loader';

import Root from './containers/Root/Root';


import * as reducers from './store/reducers';

const reducer = combineReducers({
    ...reducers,
    routing: routerReducer
});


const store = createStore(
    reducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
    applyMiddleware(
        thunkMiddleware,
        routerMiddleware(browserHistory)
    )
);

let history = syncHistoryWithStore(browserHistory, store);

const rootEl = document.getElementById('root');

ReactDOM.render(
    <AppContainer>
        <Root store={store} history={history}/>
    </AppContainer>,
    rootEl
);


if (process.env.NODE_ENV === 'development') {
    /*
     * Debugging outputs
     */
    console.log(store.getState());

    browserHistory.listen((location) => {
        console.log('location = ', location);
    });

    store.subscribe(() =>
        console.log(store.getState())
    );

    //unsubscribe();
}

console.log('module.hot = ', module.hot);

if (module.hot) {
    module.hot.accept('./containers/Root/Root', () => {
        const NextRoot = require('./containers/Root/Root').default; // eslint-disable-line global-require
        ReactDOM.render(
            <AppContainer>
                <NextRoot store={store} history={history}/>
            </AppContainer>,
            rootEl
        );
    });
}



// WEBPACK FOOTER //
// ./src/index.js